/**
 *
 * @desc 产品类型枚举值
 */
export enum ProductTypeEnum {
    JT303 = 83,
    PD303 = 48,
    JT321 = 86,
    DC303 = 85,
    YJ751 = 29,
    RE307 = 87,
}

/**
 *
 * @param {type} label 产品名称
 * @param {type} desc 产品描述
 * @param {type} type 产品类型
 */
export type ProductTypeConfig = {
    label: string;
    type: ProductTypeEnum;
    desc: string;
    deviceManageDefaultName: string;
    showDeviceOtherInfo?: boolean;
    noBindLink?: string;
    linkLabel?: string;
};

/**
 *
 * @desc 产品配置映射
 */
export const PRODUCE_TYPE_MAP: () => { [key: string]: ProductTypeConfig } = () => ({
    [ProductTypeEnum.JT303]: {
        label: 'PowerOcean',
        type: ProductTypeEnum.JT303,
        desc: '',
        deviceManageDefaultName: 'PowerOcean',
        noBindLink: 'https://www.ecoflow.com/eu/home-battery/PowerOcean',
        linkLabel: 'EcoFlow PowerOcean',
        showDeviceOtherInfo: false,
    },
    [ProductTypeEnum.DC303]: {
        label: 'PowerOcean DC Fit',
        type: ProductTypeEnum.DC303,
        desc: '',
        deviceManageDefaultName: 'PowerOcean DC Fit',
        showDeviceOtherInfo: false,
        noBindLink: 'https://enterprise.ecoflow.com/uk/solutions/home-battery/PowerOcean-DC-Fit',
        linkLabel: 'Ecoflow PowerOcean DC Fit',
    },
    [ProductTypeEnum.PD303]: {
        label: 'PD303',
        type: ProductTypeEnum.PD303,
        desc: '',
        deviceManageDefaultName: 'PowerOcean',
        showDeviceOtherInfo: false,
    },
    [ProductTypeEnum.JT321]: {
        label: 'PowerOcean Single Phase',
        type: ProductTypeEnum.JT321,
        desc: '',
        deviceManageDefaultName: 'PowerOcean',
        showDeviceOtherInfo: false,
    },
    [ProductTypeEnum.YJ751]: {
        label: 'YJ751',
        type: ProductTypeEnum.YJ751,
        desc: '',
        deviceManageDefaultName: 'PowerOcean',
        showDeviceOtherInfo: false,
    },
    [ProductTypeEnum.RE307]: {
        label: 'PowerOcean Plus',
        type: ProductTypeEnum.RE307,
        desc: '',
        deviceManageDefaultName: 'RE307',
        showDeviceOtherInfo: false,
    },
});

/**
 * @desc 用户偏好设置关联 key
 */
export const USER_LINK_PRODUCT = 'USER_LINK_PRODUCT';
